import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PopoverPosition } from '@progress/kendo-react-tooltip';
import cn from 'clsx';
import moment from 'moment';
import styles from './style.module.scss';
import { Popover } from '@components-clean/core/popover/popover';
import { useBoolean, useTranslation } from '@hooks/index';

enum MetadataArea {
    study = 'Study',
}
export interface MetadataDataProps {
    recordId: string;
    createdDate: Date;
    createdBy: string;
    updatedDate: Date;
    updatedBy: string;
    configId: string;
}

export interface MetadataProps {
    area?: MetadataArea.study;
    dataItem: MetadataDataProps;
    position: PopoverPosition;
    applyCallOutClass?: boolean;
}

const Metadata = ({ area, dataItem, position, applyCallOutClass = false }: MetadataProps) => {
    const { t } = useTranslation();
    const anchor = React.useRef<HTMLDivElement | null>(null);
    const show = useBoolean(false);

    return (
        <div className={cn(styles.triMetadata)}>
            <div
                className={styles.metadataBtn}
                onMouseEnter={() => show.setTrue()}
                onMouseLeave={() => show.setFalse()}
                ref={anchor}
            >
                <FontAwesomeIcon fontSize={16} icon={['far', 'clock-rotate-left']} className={styles.metaDataIcon} />
            </div>
            <Popover
                show={show.value}
                anchor={anchor.current}
                position={position}
                title={t('common:metadata')}
                data-testid="popover-datatestid"
                animate={false}
                isInfo={false}
                collision={{
                    vertical: 'flip',
                    horizontal: 'fit',
                }}
                applyCallOutClass={applyCallOutClass}
            >
                <div className={styles.popoverDiv}>
                    <div className={cn(styles.textWrap, 'k-mb-3')}>
                        <span className={cn(styles.label, 'k-font-normal')}>
                            {area && t('common:areaRecordId', { area })}
                            {!area && t('common:recordId')}
                        </span>
                        <span className={cn(styles.value, 'k-font-normal')}>{dataItem.recordId}</span>
                    </div>
                    <div className={cn(styles.textWrap, 'k-mb-3')}>
                        <span className={cn(styles.label, 'k-font-normal')}>
                            {area && t('common:areaCreated', { area })}
                            {!area && t('common:created')}
                        </span>
                        <span className={cn(styles.value, 'k-font-normal')}>
                            {t('common:createdUpdatedInfo', {
                                date: moment(dataItem.createdDate).format('DD-MMM-YYYY'),
                                user: dataItem.createdBy,
                            })}
                        </span>
                    </div>
                    <div className={cn(styles.textWrap, 'k-mb-3')}>
                        <span className={cn(styles.label, 'k-font-normal')}>
                            {area && t('common:areaUpdated', { area })}
                            {!area && t('common:updated')}
                        </span>
                        <span className={cn(styles.value, 'k-font-normal')}>
                            {t('common:createdUpdatedInfo', {
                                date: moment(dataItem.updatedDate).format('DD-MMM-YYYY'),
                                user: dataItem.updatedBy,
                            })}
                        </span>
                    </div>
                    <div className={styles.textWrap}>
                        <span className={cn(styles.label, 'k-font-normal')}>
                            {area && t('common:areaConfigId', { area })}
                            {!area && t('common:configId')}
                        </span>
                        <span className={cn(styles.value, 'k-font-normal')}>{dataItem.configId}</span>
                    </div>
                </div>
            </Popover>
        </div>
    );
};

export default Metadata;
